import type { Components, Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";
import {
  APPBAR_HEIGHT,
  BUTTON_HEIGHT_LARGE,
  BUTTON_HEIGHT_MEDIUM,
  BUTTON_HEIGHT_SMALL,
} from "@/constants/layout";
import {
  BLACK,
  LIGHT_ACTION_DISABLED,
  LIGHT_PRIMARY_MAIN,
} from "@/constants/colors";

const buttonOverrides = {
  MuiButton: {
    styleOverrides: {
      sizeLarge: { height: BUTTON_HEIGHT_LARGE },
      sizeMedium: { height: BUTTON_HEIGHT_MEDIUM },
      sizeSmall: { height: BUTTON_HEIGHT_SMALL },
    },
  },
  MuiFab: {
    styleOverrides: {
      sizeLarge: {
        height: BUTTON_HEIGHT_LARGE,
        minHeight: BUTTON_HEIGHT_LARGE,
        width: BUTTON_HEIGHT_LARGE,
        minWidth: BUTTON_HEIGHT_LARGE,
      },
      sizeMedium: {
        height: BUTTON_HEIGHT_MEDIUM,
        minHeight: BUTTON_HEIGHT_MEDIUM,
        width: BUTTON_HEIGHT_MEDIUM,
        minWidth: BUTTON_HEIGHT_MEDIUM,
      },
      sizeSmall: {
        height: BUTTON_HEIGHT_SMALL,
        minHeight: BUTTON_HEIGHT_SMALL,
        width: BUTTON_HEIGHT_SMALL,
        minWidth: BUTTON_HEIGHT_SMALL,
      },
    },
  },
};

const toggleButtonOverrides = {
  MuiToggleButton: {
    styleOverrides: {
      sizeLarge: { height: BUTTON_HEIGHT_LARGE },
      sizeMedium: { height: BUTTON_HEIGHT_MEDIUM },
      sizeSmall: { height: BUTTON_HEIGHT_SMALL },
    },
  },
};

const appBarOverrides = {
  MuiAppBar: { styleOverrides: { root: { height: APPBAR_HEIGHT } } },
};

const ratingOverrides = {
  MuiRating: { styleOverrides: { root: { color: LIGHT_PRIMARY_MAIN } } },
};

const backdropOverrides = (isDarkMode: boolean) => {
  const base = isDarkMode ? LIGHT_ACTION_DISABLED : BLACK;
  const from = alpha(base, 0.3);
  const to = alpha(base, 0.5);
  return {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          background: [
            BLACK,
            `-moz-linear-gradient(to top, ${from} 0%, ${to} 100%)`,
            `-webkit-linear-gradient(to top, ${from} 0%, ${to} 100%)`,
            `linear-gradient(to top, ${from} 0%, ${to} 100%)`,
          ],
          "&.MuiBackdrop-invisible": { background: "transparent" },
        },
      },
    },
  };
};

const componentsOverrides = (isDarkMode: boolean): Components<Theme> => ({
  ...buttonOverrides,
  ...toggleButtonOverrides,
  ...appBarOverrides,
  ...backdropOverrides(isDarkMode),
  ...ratingOverrides,
});

export default componentsOverrides;
